/* eslint-disable no-dupe-keys */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './translations';

i18n
  .use(initReactI18next)
  .init({
    resources: translations,
    lng: 'en', // Default language
    fallbackLng: 'en',
    debug: true, // Enable debug mode to see more info
    interpolation: {
      escapeValue: false, // React already escapes
      format: function(value, format, lng) {
        // Debug logging for interpolation
        console.log(`i18n interpolation: value=${value}, format=${format}, lng=${lng}`);
        return value;
      }
    },
    react: {
      transSupportBasicHtmlNodes: true, // Support basic HTML in translations
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'span'] // Keep these HTML elements
    },
    fileUploader: {
      dragDrop: 'Drag and drop a file here',
      or: 'or',
      browse: 'browse files',
      acceptedTypes: 'Accepted types',
      maxSize: 'Max size',
      fileSelected: 'File selected, click or drag to replace',
      clear: 'Remove',
      currentFile: 'Current file',
      clickToReplace: 'Click or drag to replace',
      fileError: 'There was an error with the file',
      invalidType: 'Invalid file type',
      tooLarge: 'File is too large'
    }
  });

// Add a debug function to help troubleshoot translations
export const debugTranslation = (key, options) => {
  const result = i18n.t(key, options);
  console.log(`Translation debug - Key: ${key}, Options:`, options, `Result: ${result}`);
  return result;
};

export default i18n; 